import { useRecoilValue } from 'recoil';
import Table from 'components/common/Table/Table';
import { timezoneState } from 'components/common/Managers/PreferencesManager.state';
import { ManagementTag } from 'common/graphqlTypes';
import { getTagsHeaders } from '../DVEndpointDetailsRenderer.utils';
import { EndpointTabs, getDefaultEndpointCardTableOptions } from '../DVEndpointDetailsRenderer.consts';
import './EndpointTagsTable.scss';

export const EndpointTagsTable = ({ tagsTableItems }: { tagsTableItems: ManagementTag[] }): JSX.Element => {
  const timezone = useRecoilValue(timezoneState);

  return (
    <Table
      headers={getTagsHeaders(timezone)}
      data={tagsTableItems}
      options={getDefaultEndpointCardTableOptions(EndpointTabs.tags)}
    />
  );
};

export default EndpointTagsTable;
